import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from '../../../shared/service/base-config.service';
import { GenericHttpService } from '../../../shared/service/generic-http.service';
import { AlterarMuncicipiosAptos, CadastraMuncicipiosAptos, DadosOnInitModelView, MunicipiosAptos } from '../model/municipios-aptos.model';



@Injectable()
export class MunicipiosAptosService {

 
  constructor(
   
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario (): Observable<DadosOnInitModelView> {
    
    return this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/DadosOnInitFormulario'), undefined);
  }

  public dadosOnInitCadastro (): Observable<DadosOnInitModelView> {
    
    return this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/DadosOnInitFormularioCadastro'), undefined);
  }

    public  gerarRelatoriodeMunicipiosAptos(dadosMunicipiosAptos:any[]): Observable<Blob>{
      const url = this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/gerarExcel');
      return this.http.reportExcel(url, dadosMunicipiosAptos);
    }
 
  /*public existeValorMensalDistribuicao(item : ConsultaMunicipiosAptos ): Observable<any> {
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/Cadastra/ExisteValorMensalDistribuicaoRoyalty'), item);
  }*/

  public registrarMunicipiosAptos(item : CadastraMuncicipiosAptos[] ): Observable<any> {    
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/RegistrarMunicipiosAptosRoyalty'), item);
  }

  public alterarrMunicipiosAptos(item : AlterarMuncicipiosAptos ): Observable<any> {    
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/AlterarMunicipiosAptosRoyalty'), item);
  }

public deletarMunicipiosAptos(item : number ): Observable<any> {    
    return this.http.delete(this.baseConfig.getBaseUrlApi().concat('/royalts/MunicipiosAptos/DeletarMunicipiosAptosRoyalty'), item);
  }

}


// WEBPACK FOOTER //
// ./src/app/royalts/shared/service/municipios-aptos.service.ts